var React = require('react');

function SubscriptionInfo (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"subscription_info","transform":"translate(-4012 -2248)"},[React.createElement("path",{"id":"Path_671","data-name":"Path 671","d":"M11,10.729a.75.75,0,1,1,1.5,0v4.5a.75.75,0,1,1-1.5,0Z","transform":"translate(4007.75 2244.005)","fill":"#231f20","key":0}),React.createElement("path",{"id":"Path_672","data-name":"Path 672","d":"M11.75,6.051a.75.75,0,1,0,.75.75A.75.75,0,0,0,11.75,6.051Z","transform":"translate(4007.75 2244.987)","fill":"#231f20","key":1}),React.createElement("path",{"id":"Path_673","data-name":"Path 673","d":"M9.5,2A7.5,7.5,0,1,0,17,9.5,7.5,7.5,0,0,0,9.5,2Zm-6,7.5a6,6,0,1,0,6-6A6,6,0,0,0,3.5,9.5Z","transform":"translate(4010 2246)","fill":"#231f20","fillRule":"evenodd","key":2})]));
}

SubscriptionInfo.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = SubscriptionInfo;

SubscriptionInfo.default = SubscriptionInfo;
